var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-none d-md-block" }, [
      _c(
        "div",
        {
          staticClass: "position-relative d-flex cursor-pointer",
          style: {
            "justify-content": _vm.getJustifyContent(),
            "align-items": _vm.getAlignItems()
          },
          on: { click: _vm.goToList }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.pluginSettings.banner, alt: "" }
          }),
          _c("div", { staticClass: "position-absolute pl-3" }, [
            _c("h1", [_vm._v(_vm._s(_vm.pluginSettings.bannerTitle))]),
            _c("h3", [_vm._v(_vm._s(_vm.pluginSettings.bannerText))])
          ])
        ]
      )
    ]),
    _c("div", { staticClass: "d-md-none", on: { click: _vm.goToList } }, [
      _c("img", {
        attrs: { width: "100%", src: _vm.pluginSettings.mobileBanner, alt: "" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }